import { format } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';

export const browserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export function timeZoneLabel(timeZone: string): string {
  try {
    const parts = new Intl.DateTimeFormat(undefined, {
      timeZone,
      timeZoneName: 'longGeneric',
    }).formatToParts(new Date());
    return parts.find(part => part.type === 'timeZoneName')?.value ?? timeZone;
  } catch {
    return timeZone;
  }
}

export function toScheduleInput(iso: string | null | undefined, timeZone: string): string {
  return iso ? format(toZonedTime(iso, timeZone), "yyyy-MM-dd'T'HH:mm") : '';
}

export function fromScheduleInput(value: string, timeZone: string): string | null {
  return value ? fromZonedTime(value, timeZone).toISOString() : null;
}
